import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';
import { toast } from 'sonner';
import { useEducations } from './useEducations';
import { useDeleteEducation } from './useDeleteEducation';
import type { Education } from '../types/education.types';

interface UseCandidateEducationsResult {
  educations: Education[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  isCreateDialogOpen: boolean;
  setIsCreateDialogOpen: Dispatch<SetStateAction<boolean>>;
  editingEducation: Education | null;
  setEditingEducation: Dispatch<SetStateAction<Education | null>>;
  handleDelete: (educationId: string) => void;
}

export function useCandidateEducations(candidateId: string): UseCandidateEducationsResult {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [editingEducation, setEditingEducation] = useState<Education | null>(null);
  const { educations, hasData, isLoading, isError } = useEducations({ candidateId });
  const { deleteEducation } = useDeleteEducation();

  const handleDelete = (educationId: string): void => {
    deleteEducation(
      { candidateId, educationId },
      {
        onSuccess: () => toast.success('Education deleted successfully'),
        onError: () => toast.error('Failed to delete education'),
      }
    );
  };

  return {
    educations,
    hasData,
    isLoading,
    isError,
    isCreateDialogOpen,
    setIsCreateDialogOpen,
    editingEducation,
    setEditingEducation,
    handleDelete,
  };
}
